import React from 'react';
import withRipple from 'jd-library/withRipple';
import style from './UOMSlider.scss';
import SearchText from '../../common/SearchText';

const UomProductList = props =>{

    return(
        <div className={style['prod-main-uom']+" "+props.rippleClass+" "+(props.subtext ? style['has-subtext'] : '')} {...props.rippleHandler} onClick={props.onClick}>
            <div className={style['prod-uom']}>
            {props.searchText ? (
						<>
							<SearchText
								search={props.searchText}
								text={props.uom  || ''}
							/>
							{props.subtext && <div className={style['subtext']}>{props.subtext}</div>}
						</>
					) : (
						<>
							<p>
								{props.uom  || ''}
							</p>
							{props.subtext && <div className={style['subtext']}>{props.subtext}</div>}
						</>
					)}
            </div>
            {props.renderRipple()}
		</div>
	)
}

export default withRipple(UomProductList);